export default "__VITE_ASSET__B2$DNhOw__"